// analytics.js — thin wrapper around gtag for event tracking.
// GA4 script loads in index.html. This module just provides named
// helpers so call sites don't need to know the gtag API.
//
// If gtag isn't loaded (ad blocker, dev mode), calls are no-ops.

function track(eventName, params = {}) {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("event", eventName, params);
  }
}

// ── Page-level events ────────────────────────────────────────────────────

/** Fire on SPA route changes (React doesn't trigger automatic pageviews) */
export function trackPageView(path, title) {
  track("page_view", { page_path: path, page_title: title });
}

// ── Conversion events ────────────────────────────────────────────────────

/** Quote/booking form submitted */
export function trackQuoteSubmit(eventType) {
  track("generate_lead", { currency: "USD", value: 0, event_type: eventType });
}

/** Shop purchase completed */
export function trackPurchase(orderId, totalCents, itemCount) {
  track("purchase", {
    transaction_id: orderId,
    value: totalCents / 100,
    currency: "USD",
    items: [{ quantity: itemCount }],
  });
}

/** Shop checkout started */
export function trackBeginCheckout(totalCents, itemCount) {
  track("begin_checkout", { value: totalCents / 100, currency: "USD", items: [{ quantity: itemCount }] });
}

// ── Engagement events ────────────────────────────────────────────────────

/** Keepsake email requested (customer wants their pancake emailed) */
export function trackKeepsakeEmail() {
  track("keepsake_email_request");
}

/** Gallery pancake viewed (rolodex or grid focus) */
export function trackGalleryView(pancakeId, title) {
  track("view_item", { item_id: pancakeId, item_name: title });
}

/** PancakeDrift pancake clicked */
export function trackDriftClick(pancakeId) {
  track("select_content", { content_type: "pancake_drift", item_id: pancakeId });
}

/** Meditation page viewed */
export function trackMeditationView(pancakeId) {
  track("view_item", { content_type: "meditation", item_id: pancakeId });
}

/** Share button tapped */
export function trackShare(method) {
  track("share", { method });
}

/** Testimonial submitted */
export function trackTestimonialSubmit() {
  track("testimonial_submit");
}
